import {Chip, Stack, Typography} from '@mui/material';

export const TagList = (tags: string[]) => {
  return (
    <Stack spacing={1} direction={'row'} alignItems={'center'}>
      {tags.map((label, index) => (
        <Chip
          label={<Typography fontSize="small">{label}</Typography>}
          key={`tag-${label}-${index}`}
          variant="filled"
          size="small"
        />
      ))}
    </Stack>
  );
};
